<template>
    <div id="app">
        <el-container>
            <el-header class="header-box">
                <div class="logo">
                    <img src="./assets/logo-2.png" />
                </div>
                <div class="menu">
                    <div class="menu-right">
                        <img @click="showMenu" src="./assets/mobile-menu-icon.png" />
                    </div>
                </div>
                <!-- <img class="nav-img" src="./assets/nav-img.png" />
                <div @click="showMenu" class="menu-icon"></div> -->
            </el-header>
            <el-main v-show="!isShowMenu">
                <router-view />
            </el-main>
            <el-footer>
                <!-- <div class="left">
                    <el-amap ref="map" :vid="'amapDemo'" :center="center" :zoom="zoom" class="amap-demo"
                        style="height: 150px;width: 100%">
                        <el-amap-marker />
                    </el-amap>
                </div>
                <div class="right">
                    <div class="name">义乌海烨电子科技有限公司</div>
                    <div class="footer-info">
                        <div class="footer-logo">
                            <img src="./assets/logo.png" />
                        </div>
                        <div class="footer-info-box">
                            <div class="item">电话：400-820-1619</div>
                            <div class="item">邮箱：haiyedanzi@163.com</div>
                            <div class="item">浙江省金华市义乌市江滨北路361号302</div>
                        </div>
                    </div>
                </div>
                <div class="footer-filing-number">
                    Copyright©2023 义乌海烨电子有限公司 版权所有 浙ICP备19029513号-2
                </div> -->
                <img class="img" src="./assets/footer-img.png" />
            </el-footer>
            <div class="menu-box" v-show="isShowMenu">
                <div class="menu-logo-close-img">
                    <!-- <div class="menu-logo">
                        <img src="./assets/logo-2.png" />
                    </div> -->
                    <div class="menu-close" @click="showMenu"><span class="el-icon-close"></span></div>
                </div>
                <el-menu :default-active="defaultActive" class="header-menu-box" mode="horizontal"
                    @select="handleSelect" :router="router">
                    <el-menu-item index="/">
                        首页
                        <div class="header-active-icon"></div>
                    </el-menu-item>
                    <el-menu-item index="/productServices">
                        产品服务
                        <div class="header-active-icon"></div>
                    </el-menu-item>
                    <el-menu-item index="/aboutUs">
                        关于我们
                        <div class="header-active-icon"></div>
                    </el-menu-item>
                    </el-menu-item>
                    <el-menu-item index="/join">
                        招商加盟
                        <div class="header-active-icon"></div>
                    </el-menu-item>
                </el-menu>
            </div>
        </el-container>
    </div>
</template>

<script>
    import Vue from 'vue';
    import VueAMap from 'vue-amap';
    Vue.use(VueAMap);
    VueAMap.initAMapApiLoader({
        key: "bc3c049b0c312fd01c78ab79f2cb7dda", //高德地图key
        plugin: ["AMap.Geocoder", 'AMap.Autocomplete'],
        v: '1.4.4'
    });

    export default {
        name: 'app',
        data() {
            return {
                router: true,
                defaultActive: "/",
                isShow: false,

                //*******************地图和组件初始化设置**********************//
                center: [120.098628, 29.315917],
                zoom: 18,

                isShowMenu: false,

                screenWidth: 0
            }
        },
        created() {
            this.screenWidth = document.body.clientWidth;
        },
        methods: {
            //打开导航栏
            showMenu() {
                this.isShowMenu = !this.isShowMenu;
            },
            //切换页面
            handleSelect(key) {
                this.isShow = this.defaultActive != key;
                this.showMenu();
                window.console.log(this.isShow);
            }
        }
    }
</script>

<style lang="scss">
    @font-face {
        font-family: 'PingFang';
        src: url('./assets/font/PingFang.ttf') format('truetype')
    }

    html,
    body {
        padding: 0px;
        margin: 0px;
        font-family: 'PingFang', sans-serif;
    }

    a {
        text-decoration: none;
    }

    .el-drawer__open .el-drawer.rtl {
        width: 70% !important;
    }

    .el-header {
        box-shadow: 0px 0px 10px #eeeeee;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 24px 30px !important;
        height: auto !important;
        background-color: #ffffff;
        position: fixed;
        top: 0px;
        z-index: 999;
        margin-bottom: 100px;
        width: 100%;

        .nav-img {
            height: 100px;
            width: 100%;
        }

        .menu-icon {
            position: absolute;
            right: 0px;
            width: 20%;
            background-color: transparent;
            z-index: 9;
            height: 100px;
        }

        .logo {
            width: 110px;
            height: 52px;
            font-size: 0;

            img {
                width: 110px;
                height: 52px;
            }
        }

        .menu {
            .menu-right {
                padding: 10px 0px;
                font-size: 0;

                img {
                    width: 32px;
                    height: 32px;
                }
            }
        }
    }

    .menu-box {
        position: absolute;
        top: 0;
        left: 0px;
        width: 100%;
        height: 100%;
        background-color: #282828;
        z-index: 999;
        overflow: hidden;

        .menu-logo-close-img {
            /* display: flex;
            flex-wrap: wrap;
            justify-content: space-between; */
            padding: 24px 30px;
            text-align: right;


            .menu-logo {
                width: 110px;
                height: 52px;
                font-size: 0;

                img {
                    width: 110px;
                    height: 52px;
                }
            }

            .menu-close {
                font-size: 45px;
                color: #FFFFFF;
            }
        }

        .el-menu::after,
        .el-menu::before {
            display: none;
        }

        .header-menu-box {
            border: none !important;

            .el-menu-item {
                font-size: 36px;
                height: 100px;
                line-height: 100px;
                width: 100%;
                color: #ffffff;
                font-weight: 600;
                padding: 0px 80px;
            }

            .is-active {
                color: #ffffff !important;
                border-bottom: none !important;

                .header-active-icon {
                    width: 14px;
                    height: 6px;
                    display: block;
                    margin: -18px auto 0px;
                }
            }
        }
    }

    .el-main {
        margin: 100px 0px 0px 0px;
        padding: 0px !important;
    }


    .footer-banner {
        background-image: url(http://img.zgwstxc.com/88de913f-5283-35c6-af38-48a81fa269be.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        padding: 90px 0px;
        text-align: center;

        .title {
            font-size: 34px;
            color: #FFFFFF;
            font-weight: bold;
        }

        .btn {
            margin-top: 30px;
            color: #ffffff;
            background-color: #1966FF;
            display: inline-block;
            border-radius: 4px;
            padding: 0px 26px;
            line-height: 50px;
            height: 50px;
            font-size: 22px;
            font-weight: bold;
        }
    }

    .el-footer {
        background-color: #313132;
        padding: 0 !important;
        height: 288px !important;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        font-size: 0px;
        margin-top: -2px;

        .img {
            width: 100%;
            height: 288px;
            background-color: #313132;
        }

        .left {
            width: 40%;
        }

        .right {
            width: 55%;

            .name {
                font-size: 22px;
                font-weight: bold;
                color: #FFFFFF;
            }

            .footer-info {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                margin-top: 30px;

                .footer-logo {
                    width: 30%;

                    img {
                        width: 98px;
                        height: 70px;
                    }
                }

                .footer-info-box {
                    width: 70%;
                    color: #F5F5F7;
                    font-size: 18px;

                    .item {
                        margin-top: 8px;
                    }

                    .item:first-child {
                        margin-top: 0px;
                    }
                }
            }
        }

        .footer-filing-number {
            font-size: 18px;
            color: #F5F5F7;
            margin-top: 40px;
            text-align: center;
        }
    }

    .banner {
        width: 100%;
        position: relative;
        font-size: 0px;
        display: block;

        img {
            width: 100%;
            height: auto;
            z-index: -1;
        }

        .banner-content {
            position: absolute;
            z-index: 9;
            top: 0px;
            left: 0px;
            text-align: center;
            width: 100%;

            .banner-title {
                font-size: 46px;
                color: #000000;
                font-weight: bold;
            }

            .banner-btn {
                background-color: #1966FF;
                font-size: 28px;
                margin-top: 238px;
                border-radius: 10px;
                height: 53px;
                line-height: 53px;
                text-align: center;
                padding: 0px 45px;
                display: inline-block;
                text-decoration: none;
                color: #ffffff;
            }
        }
    }
</style>